import SharedArticleTags, {
  IArticleTags,
} from '@organisms/ArticleTags/ArticleTags';

const ArticleTagsWrapper = (props: IArticleTags) => {
  if (!props.tags?.length) return;

  return (
    <div className="tw-mt-20">
      <SharedArticleTags {...props} />
    </div>
  );
};

export default ArticleTagsWrapper;
